<app-page-meta pageTitle="finzy - Meet the team"
			   tags="finzy, Amit More, Abhinandan Sangam, Vishwas Dixit"
			   description="The founding team comprise of folks with rich experience in banking, finance, sales, product and technology. We are a non-hierarchical, self organised set-up with cross-functional teams continuously striving to achieve ambitious business goals keeping our users at the centre of what we do.">
</app-page-meta>

<app-header>
</app-header>
<p class="faq-headertext">Meet the Team behind Finzy</p>
<div class="row faq-maindiv">

<p class="teamheading">At Finzy, we want to give people the power to follow their dreams NOW. Whether it is for that hobby you’ve been putting off, or that travel you meant to go on, or a birthday gift for a loved one. We understand that you might not have the money at this point, but you’ll get it soon.  Our goal is to help people get easy & hassle free loans.  And we do this by connecting people looking for loans and people looking to invest. If you’d like to know more about what we do, drop us a line. </p>


<div class="row teamrow">
	<a class="col-sm-4 col-xs-12 teamdiv" (mouseover)="over1()" (mouseleave)="out1()">
		<div *ngIf="d1" class="dp1">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502274931/amit_tkyjl8.png" alt="Amit More - Founder & CEO" class="teamimg">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502283542/Group_33_0.8x_h76elg.png" alt="About Amit More" class="arrowImg">
			<p class="teamp1">Amit More,</p>
			<p class="teamp2">Founder & CEO</p>
		</div>
		<div *ngIf="d1h" class="pic1">
			<p class="abtp1">Amit More</p>
			<p class="abtp2">Founder & CEO</p>
			<p class="abtp3">Amit is an expert in the Indian Banking & Financial Services industry with over 16 years of experience in a wide variety of organisations across commercial banks (ICICI Bank), investment banks (Credit Suisse AG)  as well as at Non Banking Financial Companies (Edelweiss). His taste for variety is also apparent in his personal life when he enjoys an active game of tennis or a sit-down boardgame with family with equal zeal!</p>
		</div>
	</a>
	<a class="col-sm-4 col-xs-12 teamdiv" (mouseover)="over3()" (mouseleave)="out3()">
		<div *ngIf="d3" class="dp3">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502274930/abhi_xg7lqd.png" alt="Abhinandan Sangam - Co-founder & CTO" class="teamimg">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502283542/Group_33_0.8x_h76elg.png" alt="About Abhinandan Sangam" class="arrowImg">
			<p class="teamp1">Abhinandan Sangam,</p>
			<p class="teamp2">Co-founder, Head of Product & Tech</p>
		</div>
		<div *ngIf="d3h" class="pic3">
			<p class="abtp1">Abhinandan Sangam</p>
			<p class="abtp2">Co-founder, Head of Product & Tech</p>
			<p class="abtp3">Having worked with organizations like ThoughtWorks, Sabre, MindTree, Siemens & Amadeus, Abhi is an expert in building capabilities - both in Products as well as People. Any free time is spent travelling with his wife and 2 year old daughter. His affair with travel allowed him to lead the Travel Practice at one ThoughtWorks, where he developed the digital strategy for the domain.</p>
		</div>
	</a>
	<a class="col-sm-4 col-xs-12 teamdiv" (mouseover)="over2()" (mouseleave)="out2()">
		<div *ngIf="d2" class="dp2">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502274933/vishwas_xmazwp.png" alt="Vishwas Dixit - Co-founder, Head of Sales & Marketing" class="teamimg">
			<img src="https://res.cloudinary.com/finzy/image/upload/v1502283542/Group_33_0.8x_h76elg.png" alt="About Vishwas Dixit" class="arrowImg">
			<p class="teamp1">Vishwas Dixit,</p>
			<p class="teamp2">Co-founder, Head of Sales & Marketing</p>
		</div>
		<div *ngIf="d2h" class="pic2">
			<p class="abtp1">Vishwas Dixit</p>
			<p class="abtp2">Co-founder, Head of Sales & Marketing</p>
			<p class="abtp3">Vishwas is the face of Finzy to our channel partners. He has about 23 years of Sales, Marketing & Distribution experience and is an expert in market expansion projects. Having worked with organizations like Toyota, TVS and Dunlop, Vishwas' passion to deliver more had made him a 'break through specialist'. He cherishes travel which include long drives with his wife and two kids.</p>
		</div>
	</a>
</div>
</div>

<app-footer></app-footer>